import { useState, useEffect, useCallback } from "react";
import { puvioService } from "./puvioService";

/** Primary identity hook — wraps Puvio identity for all consumers. */
export function usePuvioIdentity({ autoLoad = true } = {}) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(autoLoad);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const u = await puvioService.me();
      setUser(u);
      return u;
    } catch (e) {
      setError(e);
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { if (autoLoad) refresh(); }, [autoLoad, refresh]);

  return {
    user,
    loading,
    error,
    refresh,
    signInWithGoogle: puvioService.signInWithGoogle,
    signInAsGuest: puvioService.signInAsGuest,
    signOut: async () => { await puvioService.signOut(); setUser(null); },
    updateProfile: async (patch) => { const u = await puvioService.updateProfileMetadata(patch); await refresh(); return u; },
  };
}
